<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="section operations" style="height: 39px;">
          <div class="triggers">
            <div>
              <span style="display: inline-block;width: 90px;color: #333333">{{ $t('CargoMsg.Cargo_Months') }}</span>
              <el-input-number
                v-model="currentMonth"
                controls-position="right"
                style="margin-right: 5px;"
                @change="handleChange"
                @keyup.enter.native="handleNativeChange"
              />
              <el-button type="primary" @click="toAdd"> {{ $t('common.btn.new') }} </el-button>
              <el-button type="primary" @click="toEdit"> {{ $t('common.btn.edit') }} </el-button>
              <el-button type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
    <!-- 财务月维护 -->
    <el-dialog
      v-if="showMaintain"
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="showMaintain"
      :title="$t('CargoMsg.Cargo_AccountingMonthMaintain')"
      width="405px"
    >
      <el-form label-width="120px" label-position="right">
        <el-form-item :label="$t('CargoMsg.Cargo_DateFrom')">
          <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CompleteDate')">
          <el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EffectiveMonth')">
          <el-input v-model="form.month" disabled style="width: 220px;" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submit">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getAccountingMonthList, addAccountingMonth, updateAccountingMonth, batchDelAccountingMonth } from '@/api/accountingMonth'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getToken } from '@/utils/auth'
import ColumnUtils from '@/utils/ColumnUtils'
import { dateCompare } from '@/utils/commonUtil'

export default {
  name: 'AccountMonthGrid',
  components: { cargoAdvanceSelect },
  data() {
    return {
      sessionId: getToken(),
      loading: false,
      gridParams: {},
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_DateFrom'),
          field: 'startDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CompleteDate'),
          field: 'endDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EffectiveMonth'),
          field: 'month'
        }],
      rowData: [],
      currentMonth: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      showMaintain: false,
      initForm: {
        startDate: '',
        endDate: '',
        month: 1
      },
      form: {
        startDate: '',
        endDate: '',
        month: 1
      }
    }
  },
  computed: {
    computeCurrentMonth() {
      const date = new Date()
      return date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0')
    }
  },
  mounted() {
    // 初始化当前月份
    this.currentMonth = this.computeCurrentMonth
    this.fetchAccountingMonthList()
  },
  methods: {
    handleChange(value) {
      if (!value) value = this.computeCurrentMonth
      value = value + ''
      this.currentMonth = this.generationMonth(value)
      this.fetchAccountingMonthList()
    },
    handleNativeChange() {
      if (!this.currentMonth) this.currentMonth = this.computeCurrentMonth
      this.currentMonth = this.generationMonth(this.currentMonth)
      this.fetchAccountingMonthList()
    },
    // 生成月份 格式yyyyMM
    generationMonth(value) {
      if (value) {
        // 获取月份
        let year = value.slice(0, 4)
        // 获取年份
        let month = value.slice(4)

        if (month > 12) {
          year = Number(year) + 1
          month = '01'
        }
        if (month <= 0) {
          year = Number(year) - 1
          month = '12'
        }
        return year + month
      }
      return ''
    },
    // 获取财务月列表
    fetchAccountingMonthList() {
      const self = this
      const params = {}
      if (this.currentMonth) {
        params.anyStr = this.currentMonth
      }
      this.loading = getLoading()
      getAccountingMonthList(params).then(res => {
        self.rowData = res.data
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    },
    rowSelected(event) {
      if (event.node.isSelected()) {
        this.selectedRow = event.node.data
      }
    },
    toAdd() {
      this.form = { ...this.initForm }
      this.form.month = this.currentMonth
      this.showMaintain = true
    },
    toEdit() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length !== 1) {
        this.$message.error(this.$t('common.tips.hasOneOnly'))
        return
      }
      this.form = { ...rows[0] }
      this.showMaintain = true
    },
    // 删除
    toDelete() {
      const self = this
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.loading = getLoading()
        const ids = Array.from(rows, p => p.uuid)
        batchDelAccountingMonth(ids).then(() => {
          self.$message.success(self.$t('common.tips.deleteSuccess'))
          self.fetchAccountingMonthList()
        }).finally(() => {
          self.loading.close()
        })
      }).catch(() => { })
    },
    submit() {
      if (!this.form) return
      if (!this.form.startDate || !this.form.endDate) {
        this.$message.error(this.$t('Information.StartEndDateCannotEmpty'))
        return
      }
      // const startDate = ColumnUtils.dateMonthFunc(this.form.startDate)
      // const endDate = ColumnUtils.dateMonthFunc(this.form.endDate)
      // if (startDate && endDate && (Number(startDate) !== Number(this.form.month) || Number(endDate) !== Number(this.form.month))) {
      //   this.$message.error('日期月份必须保持一致!')
      //   return
      // }
      if (dateCompare(this.form.endDate, this.form.startDate) <= 0) {
        this.$message.error(this.$t('Information.StartBeEarlierThanDate'))
        return
      }

      if (!this.form.uuid) {
        this.loading = getLoading()
        addAccountingMonth(this.form).then(res => {
          this.showMaintain = false
          if (res.data > 0) {
            this.$message.success(this.$t('common.tips.saveSuccess'))
          }
          this.fetchAccountingMonthList()
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.loading = getLoading()
        updateAccountingMonth(this.form).then(res => {
          this.showMaintain = false
          if (res.data > 0) {
            this.$message.success(this.$t('common.tips.editSuccess'))
          }
          this.fetchAccountingMonthList()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.showMaintain = false
    }
  }
}
</script>
